import React from 'react';

const jobSeekerMessages = {
  value: (
    <>
      <u>Specific Uses – Job Seeker:</u>
    </>
  ),
  list: [
    {
      value: (
        <>
          Job Seeker agrees that he/she shall only use the Site for lawful
          purposes and seeking employment.
        </>
      ),
    },
    {
      value: (
        <>
          Job Seeker agrees to keep his/her login name and password with care
          and not to disclose them to any other person. Job Seeker is solely
          responsible for maintaining the confidentiality, safekeeping and
          security of such login name and password and shall notify Glints
          immediately of any unauthorized use of the same.
        </>
      ),
    },
    {
      value: (
        <>
          Job Seeker confirms and acknowledges that he/she discloses his/her
          personal data and all other information to the Advertisers and/or
          Glints of his/her own volition when he/she applies for available job
          vacancies posted on or through the Site, and/or when Job Seeker uses
          the Site for purposes of submitting, uploading or posting his/her
          resume on the Site. By submitting, uploading or posting his/her resume
          on the Site, Job Seeker authorizes Glints to store his/her resume and
          information or data related thereto in the database of Glints
          (“Database”). Job Seeker may send his/her resume and the related
          information or data directly to any Advertiser who advertises on or
          through the Site. Alternatively, Job Seeker may send his/her resume
          and the related information or data to Glints through the Site in
          reply to any job advertisement. In such an event, Job Seeker’s resume
          and the related information or data will remain active on the Site and
          be stored in the Database at his/her own risk unless and until he/she
          chooses to delete them. Job Seeker acknowledges and agrees that
          his/her resume and the related information or data may be accessed by
          the Advertisers who have subscribed to the services of Glints for the
          sole purpose of recruiting and assessing the suitability of Job
          Seekers. Glints also reserves the right to reject, disapprove or edit
          any part of the Job Seeker’s resume and information or data related
          thereto as it sees appropriate and to erase any personal data which
          Glints reasonably believes that such information or data are
          inaccurate, false, illegal, unlawful, infringe copyright / trademark /
          trade name / trade secret or infringe any other intellectual property
          rights or invade the privacy of the other having regard to the purpose
          (including any directly related purpose) for which the data are or are
          to be used.
        </>
      ),
    },
    {
      value: (
        <>
          Job Seeker acknowledges and agrees to Glint&apos;s practice of
          charging Advertiser a fee for access to the Site, the Database and/or
          Job Seekers’ resumes, details and information or data related thereto
          for the sole purpose of recruiting and assessing the suitability of
          Job Seekers and subject to the terms herein. Job Seeker also
          recognizes that he/she shall have no claims to any such fee received
          by Glints.
        </>
      ),
    },
    {
      value: (
        <>
          Glints will not release Job Seeker’s personal data to any Advertiser
          without his/her permission unless required by any authorized
          institution or obliged under the prevailing laws and regulations. Job
          Seeker acknowledges and agrees that Glints will, if he/she so
          authorizes, release his/her resume (without his/her personal and
          contact information and name of his/her current employer) to
          Advertiser through the use of Glints’ search engine or any other means
          for the sole purpose of enabling Advertiser to recruit and assess the
          suitability of Job Seekers in relation to any job vacancy. Job Seeker
          agrees that Glints and its associated companies may use his/her
          personal data (without his/her name, address and other personal
          identifiable information) for marketing purposes which may be directed
          to either potential Advertisers, their respective agents or anyone
          under their employ.
        </>
      ),
    },
    {
      value: (
        <>
          Although Glints shall use its reasonable endeavors to restrict access
          to the Database only to the Advertisers and personnel of Glints, it
          does not guarantee that other parties will not, without Glints’
          consent, gain access to the Database. Job Seeker may disable searching
          or viewing of his/her resume by the Advertisers at any time. However,
          Job Seeker acknowledges that the Advertisers and other parties who
          have otherwise gained access to the Database may have retained a copy
          of Job Seeker’s resume. Glints is not responsible for the retention,
          use or privacy of resumes in these instances, or for the use or
          privacy of resumes by any of such parties while the resumes are in the
          Database.
        </>
      ),
    },
    {
      value: (
        <>
          Glints will not be responsible or held liable in any way if any
          Advertiser or other user, in breach of the Terms and Conditions,
          whether in Singapore or elsewhere, uses the Job Seeker’s personal
          data, information or materials for any purpose other than for
          recruiting potential employees. Job Seeker accepts that all personal
          data, information or materials given to Advertiser or other users, or
          submitted on or through the Site, are given entirely at his/her own
          risk.
        </>
      ),
    },
  ],
};

const advertiserMessages = {
  value: (
    <>
      <u>Specific Uses – Advertiser:</u>
    </>
  ),
  list: [
    {
      value: (
        <>
          Advertiser agrees that it shall only use the Site for lawful purposes
          and promoting any job related activities. If Advertiser has elected to
          also acquire any of Glints Products (“Glints Products”), these Terms
          and Conditions are to be read in conjunction with Glints Products’
          specifications, which will be provided on request.
        </>
      ),
    },
    {
      value: (
        <>
          Upon payment of the service fee to Glints or upon acceptance of any
          free trial promotion offer, Advertiser will be entitled to use the
          Site to advertise job vacancies and/or to create its own web page on
          the Site for a predetermined period following agreement of the
          predetermined service, save and except for free trial promotion offer.
          Subject to the conditions or requirements from time to time stipulated
          by Glints regarding the access to Job Seeker’s information or data,
          Advertiser will be entitled to access the Database but agrees that all
          information or data obtained as a result of such access shall only be
          used for the sole purpose of recruiting and assessing the suitability
          of Job Seekers and that such information or data shall not be
          disclosed to any other parties without the prior consent of the Job
          Seeker concerned. Advertiser acknowledges and agrees that it shall
          disregard any information or data received from Job Seeker which is
          irrelevant to recruiting and assessing the suitability of Job Seekers.
        </>
      ),
    },
    {
      value: (
        <>
          Advertiser shall be solely responsible for the contents of and
          materials contained in its advertisement and/or web page posted on the
          Site. Glints reserves the right to remove or edit, or require the
          removal or amendment of, any advertisement or web page as it sees
          appropriate, or to terminate or suspend the Advertiser’s access and
          use of the Site and/or services offered on or through the Site, in
          accordance with the agreement for such services between Advertiser and
          Glints.
        </>
      ),
    },
    {
      value: (
        <>
          Glints shall have the right to terminate any services offered to any
          Advertiser and to remove any advertisement and/or web page posted on
          the Site at Glints’ sole discretion, without any compensation or
          recourse to Advertiser in the event that the relevant Advertiser or
          the contents of the relevant advertisement and/or web page is or are
          in breach of any of the provisions herein or any of the provisions in
          the TERMS AND CONDITIONS OF SALE, Policy Statement or any Glints
          Products’ specifications; whereas, in the event that Glints decides to
          remove an advertisement or web page for any reasons not relating to
          any breach of the provisions herein or any of the provisions in the
          TERMS AND CONDITIONS OF SALE, Policy Statement or any Glints Products’
          specifications, Glints may after deducting the fees charged for the
          period that the advertisement or web page has been posted on the Site,
          refund the remaining fees (if any) to the relevant Advertiser.
        </>
      ),
    },
    {
      value: (
        <>
          From time to time Glints may invest in marketing campaigns to promote
          your employer brand (including but not limited to Google ads, Yahoo –
          Bing ads, Baidu ads, Facebook ads, Twitter ads, ad networks, Demand
          Side Platforms, Real Time Bidding, retargeting and other programmatic
          buying strategies) and acknowledge that such promotion may be outside
          the domain of Glints or its subsidiaries / affiliates.
        </>
      ),
    },
    {
      value: (
        <>
          Glints also reserves the right to change the service fee or institute
          new charges or fees, from time to time, as it deems appropriate. In
          the event that any Advertiser fails to pay the service fee or any
          other fees or charges due to Glints, Glints reserves the right to
          suspend or terminate the Advertiser’s web page and/or advertisement
          and/or right to access the Database, without prejudice to all other
          rights and remedies available to Glints.
        </>
      ),
    },
  ],
};

const prohibitedUsersMessages = {
  value: (
    <>
      <u>Prohibited Uses – Users: </u>
    </>
  ),
  list: [
    {
      value: <>Users agree(s) that:</>,
    },
    {
      value: (
        <>
          Job Seeker shall not post any non-resume related information or data
          and/or incomplete, false or inaccurate resume related information or
          data on the Site.
        </>
      ),
    },
    {
      value: (
        <>
          Job Seeker shall not respond to any job vacancy advertisement for any
          reason other than to apply for the job advertised, and Advertiser
          shall not respond to any Job Seeker other than in connection with
          his/her application for a job. Any communications or use of the Site
          for any purposes other than recruitment purposes, including but not
          limited to soliciting of donations or business for any reason, are
          strictly prohibited.
        </>
      ),
    },
    {
      value: (
        <>
          All users shall not use the Site in any manner that infringes the
          intellectual property rights or proprietary rights of others.
        </>
      ),
    },
    {
      value: (
        <>
          All users shall not print, download, duplicate, transmit or otherwise
          copy, reproduce, redistribute, republish or use any personally
          identifiable information about other users save and except that the
          Advertisers may use the Database and/or Job Seekers’ resumes and the
          information or data related thereto pursuant to Section 1.1.5 as
          above. All unsolicited communications of any type to users are
          strictly prohibited.
        </>
      ),
    },
    {
      value: (
        <>
          All users shall not delete, revise or remove any material posted by
          any other person or entity.
        </>
      ),
    },
    {
      value: (
        <>
          All users are prohibited from violating or attempting to violate the
          security of the Site including, without limitation, accessing data not
          intended for them or logging into a server or account which they are
          not authorized to access, attempting to probe, scan or test the
          vulnerability of a system or network or attempting to breach security
          or authentication measures without proper authorization, attempting to
          interfere with service to any user, host or network or sending
          unsolicited e-mails, including promotions and/or advertisements for
          products or services. Violations of system or network security may
          result in civil and/or criminal liabilities, including under the
          Computer Misuse Act (Cap. 50A) and the Spam Control Act (Cap. 311A).
        </>
      ),
    },
    {
      value: (
        <>
          All users shall not upload, post, publish, transmit, distribute,
          circulate or store any material in whatsoever way relating to the Site
          (i) in violation of any applicable laws or regulations; (ii) in any
          manner that may infringe the copyright, trademark, trade secrets or
          other intellectual property rights or proprietary rights of others or
          violate the privacy or publicity or other personal rights of others;
          (iii) that is harmful, defamatory, libelous, obscene, discriminatory,
          harassing, threatening, abusive, hateful, racist, blasphemous, false,
          illegal, improper or is otherwise offensive or objectionable; (iv) in
          the manner that causes unrest in politics, religion, national security
          or stability of Glints; or (v) that contains viruses, trojan horses,
          worms, corrupted files or other materials or programs that may
          interrupt, damage or limit the functionality and operation of the
          Site, the services offered on the Site, or of any computer software or
          hardware or telecommunication equipment.
        </>
      ),
    },
    {
      value: (
        <>
          All users are prohibited in using screen scraping, data mining, robots
          or similar data gathering and extraction tools on the Site for
          establishing, maintaining, advancing or reproducing information
          contained on our Site on your own website or in any other publication,
          except with our prior written consent.
        </>
      ),
    },
  ],
};

export const acceptableSiteUsesMessages = {
  value: 'Acceptable Site Uses',
  list: [jobSeekerMessages, advertiserMessages, prohibitedUsersMessages],
};
